import React, { useState, useEffect } from 'react';
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";

import {
    Container,
    Button,
    ListItem,
    ListWrapper
} from './styles';

interface Props {
    options: any;
    onCampaignIdChange: (id: number) => void; // Callback para retornar o valor
    initialCampaignId: any;
}

const ProducerCarousel: React.FC<Props> = ({ options, onCampaignIdChange, initialCampaignId }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
      if (initialCampaignId && options.length > 0) {
        const initialIndex = options.findIndex((option: any) => option.id === initialCampaignId);
        if (initialIndex !== -1) {
          setCurrentIndex(initialIndex);
        }
      }
    }, [initialCampaignId, options]);
  
    const handleNext = () => {
      if (currentIndex < options.length - 1) {
        const currentValue = currentIndex + 1;
        setCurrentIndex(currentValue);
        const campaignId = options[currentValue].id;
        onCampaignIdChange(campaignId); 
      }
    };
  
    const handlePrev = () => {
      if (currentIndex > 0) {
        const currentValue = currentIndex - 1;
        setCurrentIndex(currentValue);
        const campaignId = options[currentValue].id;
        onCampaignIdChange(campaignId);
      }
    };

    useEffect(() => {
        if (options.length > 0) {
            
        }
    }, [currentIndex, options, onCampaignIdChange]);
  
    return (
      <Container>
        <Button onClick={handlePrev}>
            <AiOutlineLeft/>
        </Button>
        <ListWrapper>
          {options.slice(currentIndex, currentIndex + 1).map((item: any) => (
            <ListItem key={item.id}>
              Safra {item.label}
            </ListItem>
          ))}
        </ListWrapper>
        <Button onClick={handleNext}>
            <AiOutlineRight/>
        </Button>
      </Container>
    );
};

export default ProducerCarousel;